let socket;
let isConnected = false;
let locationId = null;
let deviceId = null;
const hostname = window.location.hostname;

function connectWebSocket() {
  // Check if there's already a global WebSocket connection
  if (
    window.globalSocket &&
    window.globalSocket.readyState === WebSocket.OPEN
  ) {
    socket = window.globalSocket;
    isConnected = true;
    console.log("✅ Reusing existing WebSocket connection");
    return;
  }

  if (!isConnected && (!socket || socket.readyState === WebSocket.CLOSED)) {
    const protocol = location.protocol === "https:" ? "wss" : "ws";
    socket = new WebSocket(`${protocol}://${hostname}/ws`);

    // Store the socket globally for reuse
    window.globalSocket = socket;
    document.globalSocket = socket;

    socket.onopen = function () {
      console.log("✅ Connected to WebSocket server");
      isConnected = true;
    };

    socket.onmessage = function (event) {
      try {
        const data = JSON.parse(event.data);

        if (data.type && data.type === "verifone") {
          const verifoneSerialNumber = localStorage.getItem("verifoneSerialNumber") || '';
          if (verifoneSerialNumber && data.verifoneSerialNumber != verifoneSerialNumber) {
            return;
          }

          if (data.action === "start_payment") {
            if ($("body").attr("is-verifone-session-started") == '1' && $("#standby-terminal-container").length) {
              if (isTerminalBusy) {
                socket.send(JSON.stringify({type: "verifone", action: "terminal_busy", verifoneSerialNumber: data.verifoneSerialNumber, senderDeviceId: localStorage.getItem("deviceID")}));
                return;
              }
              isTerminalBusy = true;
              const paymentData = data.paymentData;

              localStorage.setItem('verifoneProcessData', JSON.stringify(data));

              passVerifoneDataToWebView(paymentData);
            }
          } else if (data.action === "check_availability") {
            const localDeviceId = localStorage.getItem("deviceID");

            if (data.senderDeviceId !== localDeviceId &&
                data.verifoneSerialNumber == verifoneSerialNumber &&
                $("body").attr("is-verifone-session-started") == '1' &&
                $("body").attr("p") == 'payment_standby_mode' &&
                !isTerminalBusy) {
              // Send targeted "available" response
              socket.send(JSON.stringify({
                type: "verifone",
                action: "terminal_available",
                verifoneSerialNumber: data.verifoneSerialNumber,
                targetDeviceId: data.senderDeviceId,
                senderDeviceId: localDeviceId
              }));
            }
          } else if (data.action === "terminal_available") {

            const terminalId = data.verifoneSerialNumber;
            const button = $(`.order-button[data-terminal-id="${terminalId}"]`);
            const quickOrderButton = $(`.quick-order-button[data-terminal-id="${terminalId}"]`);
            if (button.length && locationCart.products.length > 0) {
              button.prop("disabled", false);
            }

            if (quickOrderButton.length && locationCart.products.length > 0) {
              quickOrderButton.prop("disabled", false);
            }

          } else if (data.action === "terminal_unavailable") {

            const terminalId = data.verifoneSerialNumber;
            const button = $(`.order-button[data-terminal-id="${terminalId}"]`);
            const quickOrderButton = $(`.quick-order-button[data-terminal-id="${terminalId}"]`);
            if (button.length) {
              button.prop("disabled", true);
            }

            if (quickOrderButton.length) {
              quickOrderButton.prop("disabled", true);
            }

          } else if (data.action === "user_cancelled_payment") {
            const modalHTML = `
                  <div class="icon-container" style="margin-bottom: 48px; margin-top: 48px;">
                      <span class="pulse-layer"></span>
                      <div class="xmark show" id="xmark"></div>
                  </div>
                  <div class="status-title" id="statusTitle">Betalingen ble avbrutt av brukeren.</div>
            `

            if ($("#payment-status").length) {
              $("#payment-status").html(modalHTML);
              $("#payment-status").removeClass("processing").addClass("failed");
            }

            if (!$("#externalPaymentProcessModal").hasClass("show")) {
              $("#externalPaymentProcessModal").modal('show');
            }
          } else if (data.action === "declined_payment") {
            const modalHTML = `
                  <div class="icon-container" style="margin-bottom: 48px; margin-top: 48px;">
                      <span class="pulse-layer"></span>
                      <div class="xmark show" id="xmark"></div>
                  </div>
                  <div class="status-title" id="statusTitle">Betalingen ble avvist. Vennligst prøv igjen.</div>
            `

            if ($("#payment-status").length) {
              $("#payment-status").html(modalHTML);
              $("#payment-status").removeClass("processing").addClass("failed");
            }

            if (!$("#externalPaymentProcessModal").hasClass("show")) {
              $("#externalPaymentProcessModal").modal('show');
            }
          } else if (data.action === "completed_payment") {
            const modalHTML = `
                  <div class="icon-container" style="margin-bottom: 48px; margin-top: 48px;">
                      <span class="pulse-layer"></span>
                      <div class="checkmark show" id="checkmark"></div>
                  </div>
                  <div class="status-title" id="statusTitle">Betaling godkjent.</div>
            `

            if ($("#payment-status").length) {
              $("#payment-status").html(modalHTML);
              $("#payment-status").removeClass("processing failed");
            }

            if (!$("#externalPaymentProcessModal").hasClass("show")) {
              $("#externalPaymentProcessModal").modal('show');
            }

            setTimeout(() => {
              if ( $("#externalPaymentProcessModal").hasClass('show')) {
                $("#externalPaymentProcessModal").modal('hide');
              }

              emptyAllCart("order_complete");
              closePanel();
            }, 1000)
          }
          return;
        }

        if (data.type === "ping_device" && data.target_device_id === deviceId) {
          const pongData = {
            type: "pong",
            from_device_id: deviceId,
            original_sender: data.sender_id,
          };
          socket.send(JSON.stringify(pongData));
          return;
        }

        if (
          (data.type && data.type === "created_start_balance") ||
          data.type === "created_z_report"
        ) {

            if (data?.zReportData && data.zReportData.main_pos_device_id === deviceId) {
                passDataToWebView(
                    event,
                    "print_z_report",
                    data.zReportData.printData,
                    data.zReportData.ipAddress,
                    data.zReportData.type
                )
            }

          const locationIdFromStorage = localStorage.getItem(
            data.organizer_id + "_mainLocationId"
          );
          if (locationIdFromStorage == data.location_id) {
            $.ajax({
              url: "/api/v1/check-login",
              method: "GET",
              dataType: "json",
            }).done(function (data) {
              if (data && data.isLoggedIn) {
                if ($("body").attr("p") === "starting_cash_balance") {
                  window.location.reload();
                  return;
                }

                if (data.redirect_url) {
                  window.location.href = data.redirect_url;
                }
              }
            });
          }
          return;
        }

        if (
          data.type &&
          data.type === "web_print_order" &&
          data.main_pos_device_id === deviceId
        ) {
          passDataToWebView(
            event,
            "web_print_order",
            [data.order_data],
            null,
            null,
            null,
            null,
            data.requested_device_id
          );
          return;
        }

        if (
          data.type &&
          data.type === "advance_receipt" &&
          data.main_pos_device_id === deviceId
        ) {
          passDataToWebView(
            event,
            "advance_receipt",
            data.orderProducts,
            data.ipAddress,
            data.printerType,
            data.organizer,
            null,
            data.requested_device_id
          );
          return;
        }

        // If the order is complete and matches this screen
        if (
          data.type &&
          (data.type === "order_complete" || data.type === "order_cancelled") &&
          data.deviceId
        ) {
          resetCustomerScreen(data, data.type);
          return;
        }

        updateCustomerScreen(data);
      } catch (e) {
        console.error("❌ Invalid JSON from server:", e);
      }
    };

    socket.onclose = function () {
      console.warn("⚠️ WebSocket closed");
      isConnected = false;
      window.globalSocket = null;
    };

    socket.onerror = function (error) {
      console.error("❌ WebSocket error:", error);
    };
  }
}

function updateCustomerScreen(data) {
  const POSDeviceId = data.deviceId;
  const connectedDeviceId = $("body").attr("deviceId");

  if (POSDeviceId !== connectedDeviceId) {
    return;
  }

  if ($(".customer-screen-view-container").hasClass("mobile")) {
    $(".carousel-contanier").addClass("d-none");
    $(".checkout-screen-container ").removeClass("d-none");
    $(".checkout-screen-container ").addClass("w-100");
  } else {
    if ($(".carousel-contanier").hasClass("w-100")) {
      $(".carousel-contanier").removeClass("w-100");
      $(".carousel-contanier").addClass("w-50");
      $(".carousel-contanier").css("padding-right", "16px");
    }
    if ($(".checkout-screen-container ").hasClass("d-none")) {
      $(".checkout-screen-container ").removeClass("d-none");
      $(".checkout-screen-container ").addClass("w-50");
    }
  }
  const $checkout = $(".customer-screen-checkout");
  $checkout.empty();

  if (Array.isArray(data.products)) {
    $.each(data.products, function (index, product) {
      const productPrice =
        parseFloat(product.price) *
        (1 - parseFloat(product.discount_percent) / 100);

      const mainDiv = $("<div>").addClass("product-detail");
      const productDetailsDiv = $("<div>")
        .addClass("product-name")
        .text(
          `${product.quantity} x ${decodeHtml(product.name)}${
            parseFloat(product.discount_percent) > 0
              ? ` (${product.discount_percent}%)`
              : ""
          }`
        );

      // Add product extras if they exist
      if (product.product_extra) {
        $.each(product.product_extra, function (i, extra) {
          const extraDiv = $("<div>").addClass("extra-item w-100 pl-4");
          const extraDetailsDiv = $("<div>")
            .addClass("product-name")
            .text(`- ${decodeHtml(extra.extra_name)} x ${extra.amount}`);

          extraDiv.append(extraDetailsDiv);
          productDetailsDiv.append(extraDiv);
        });
      }
      const priceDiv = $("<div>")
        .addClass("product-price")
        .text(`${formattedPriceToShow(productPrice)} kr`);

      mainDiv.append(productDetailsDiv).append(priceDiv);

      $checkout.append(mainDiv);
    });
  }
  const totalPrice = parseFloat(data.total);
  const totalDiscountPrice = parseFloat(data.total_with_discount);

  $("#discount-percent").text(
    ` ${formattedPriceToShow(data.discount_percent)} %`
  );
  $("#total-price").text(` ${formattedPriceToShow(totalPrice)} kr`);
  $("#total-discount-price").text(
    ` ${formattedPriceToShow(totalDiscountPrice)} kr`
  );
}

function resetCustomerScreen(data, type) {
  const POSDeviceId = data.deviceId;
  const connectedDeviceId = $("body").attr("deviceId");

  if (POSDeviceId != connectedDeviceId) {
    return;
  }

  if (type === "order_complete") {
    $(".customer-screen-checkout")
      .empty()
      .append(
        '<div class="confirmation-toast w-100">' +
          '<div class="d-flex flex-column justify-content-center align-items-center w-100">' +
          '<div id="success-icon" class="rounded-full text-success"><i class="material-icons">check_circle_outline</i></div>' +
          "<div>Takk for handelen!</div>" +
          "</div>" +
          "</div>"
      );

    setTimeout(() => {
      if ($(".customer-screen-view-container").hasClass("mobile")) {
        $(".carousel-contanier").removeClass("d-none").addClass("w-100");
        $(".checkout-screen-container").removeClass("w-100").addClass("d-none");
        $(".carousel-contanier").css("padding-right", "0");
      } else {
        console.log("Resetting customer screen for desktop view");
        $(".confirmation-toast").remove();
        $(".customer-screen-checkout").empty();
        $("#total-price").text("");
        $(".carousel-contanier").removeClass("w-50").addClass("w-100");
        $(".carousel-contanier").css("padding-right", "0");
        $(".checkout-screen-container").removeClass("w-50").addClass("d-none");
      }
    }, 3000);
  } else if (type === "order_cancelled") {
    $(".customer-screen-checkout").empty();
    if ($(".customer-screen-view-container").hasClass("mobile")) {
      $(".carousel-contanier").removeClass("d-none").addClass("w-100");
      $(".checkout-screen-container").removeClass("w-100").addClass("d-none");
      $(".carousel-contanier").css("padding-right", "0");
    } else {
      $(".confirmation-toast").remove();
      $(".customer-screen-checkout").empty();
      $("#total-price").text("");
      $(".carousel-contanier").removeClass("w-50").addClass("w-100");
      $(".carousel-contanier").css("padding-right", "0");
      $(".checkout-screen-container").removeClass("w-50").addClass("d-none");
    }
  }
}

function sendUpdateToServer(data) {
  if (socket && socket.readyState === WebSocket.OPEN) {
    socket.send(JSON.stringify(data));
  } else {
    console.warn("⚠️ Cannot send, WebSocket not connected");
  }
}

$(document).ready(function () {
  let p = $("body").attr("p");
  deviceId = $("body").attr("device_id");

  if (!(p == "customer_screen" || p == "events" || p == "payment_standby_mode")) {
    if ((socket && socket.readyState === WebSocket.OPEN) || isConnected) {
      socket.close();
    }
  }

  if (p == "customer_screen") {
    connectWebSocket();
    $("header").hide();

    $(document).on("submit", "#device-id-form", function (e) {
      e.preventDefault();
      const POSDeviceId = $("#device-id").val();
      locationId = $("#location-id").val();

      const disabledOnClick = $("#to-customer-screen");
      const btnWidth = disabledOnClick.outerWidth();
      disabledOnClick.css("width", btnWidth + "px");
      disabledOnClick.prop("disabled", true);
      disabledOnClick.html('<i class="spinner-border spinner-border-sm"></i>');

      $.ajax({
        type: "POST",
        url: "/api/v1/private/customer-screen/check-device-id",
        data: {
          location_id: locationId,
          device_id: POSDeviceId,
        },
      })
        .done(function (data) {
          disabledOnClick.prop("disabled", false);
          disabledOnClick.html("Bekreft");
          if (data.success) {
            window.location.href =
              window.location.pathname + "?deviceId=" + POSDeviceId;
          } else {
            alert(data.message);
          }
        })
        .fail(function (data) {
          disabledOnClick.prop("disabled", false);
          disabledOnClick.html("Bekreft");
          alert("Failed to set device ID.");
          return;
        });
    });
  }
});
